import { render, staticRenderFns } from "./SavFooter.vue?vue&type=template&id=f6e2bd4a&"
import script from "./SavFooter.vue?vue&type=script&lang=js&"
export * from "./SavFooter.vue?vue&type=script&lang=js&"
import style0 from "./SavFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VContainer,VDivider,VFooter})
